(function () {
  if (typeof window !== 'undefined' && window.BFLander) return;

function timeLeft(endMs, nowMs) {
  if (isNaN(endMs) || endMs <= nowMs) return null;
  const s = Math.floor((endMs - nowMs) / 1000);
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60,
  };
}

// A promo occupies its slot and pushes later products down, so a slot may
// sit one past the end of everything placed before it.
function slotPromos(itemCount, positions) {
  const sorted = Array.from(new Set(positions)).sort((a, b) => a - b);
  const slots = [];
  sorted.forEach((p) => {
    if (p <= itemCount + slots.length + 1) slots.push(p);
  });
  return slots;
}

function findVariantBySize(variants, size) {
  const needle = size.toLowerCase().trim();
  if (!needle) return null; // '' would match every variant
  const matches = variants.filter((v) =>
    v.options.some((o) => o.toLowerCase().includes(needle))
  );
  return matches.find((v) => v.available) || matches[0] || null;
}

function bundleTotals({ bedPrice, bedCompare, mattressPrice, mattressCompare, discountPct }) {
  const mattressSale = Math.round((mattressPrice * (100 - discountPct)) / 100);
  const total = bedPrice + mattressSale;
  const compareTotal = (bedCompare || bedPrice) + (mattressCompare || mattressPrice);
  return { mattressSale, total, compareTotal, savings: compareTotal - total };
}

function monthly(priceCents, months) {
  return months > 0 ? Math.ceil(priceCents / months / 100) * 100 : 0;
}

// Promo tile positions (1-based) and product count for `pages` pages of `pageSize`.
// p fits only if every product before it exists: p - 1 - placed <= total (p == total + placed + 1 is the end slot).
function pageLayout(total, pages, positions, pageSize = 8) {
  const cap = pages * pageSize;
  const slots = [];
  [...new Set(positions)].sort((a, b) => a - b).forEach((p) => {
    if (p <= cap && p <= total + slots.length + 1) slots.push(p);
  });
  return { shown: Math.min(total, cap - slots.length), slots };
}

// data-pos=" all:3 murphy-beds:1 " -> { all: 3, 'murphy-beds': 1 } (1-based order per tab).
function parsePositions(attr) {
  const pos = {};
  attr.trim().split(/\s+/).forEach((t) => {
    const i = t.lastIndexOf(':');
    const n = Number(t.slice(i + 1));
    if (i > 0 && Number.isInteger(n) && n > 0) pos[t.slice(0, i)] = n;
  });
  return pos;
}

// Items listed in `tab`, in SKU-list order (Array#sort is stable, so ties keep DOM order).
const tabOrder = (items, tab) => items.filter((i) => i.pos[tab]).sort((a, b) => a.pos[tab] - b.pos[tab]);

// Cheapest priced item in `tab` (ties keep SKU order); null if none. Price <= 0 or NaN is ignored.
const cheapestInTab = (items, tab) => tabOrder(items, tab)
  .filter((i) => Number.isFinite(i.price) && i.price > 0)
  .reduce((a, b) => (a && a.price <= b.price ? a : b), null);

const pad = (n) => String(n).padStart(2, '0');
// Never parse a date without an offset (Date.parse would assume local time).
const HAS_OFFSET = /(Z|[+-]\d{2}:\d{2})$/i;

// Lazy video: sources load and play only near the viewport. Returns the observer.
function lazyVideo(video) {
  video.muted = true;
  let loaded = false;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) {
        if (!loaded) {
          loaded = true;
          video.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; });
          video.load();
        }
        const p = video.play();
        if (p && p.catch) p.catch(() => {}); // autoplay can be blocked
      } else if (loaded) video.pause();
    });
  }, { rootMargin: '300px' });
  io.observe(video);
  return io;
}

function bfCountdown(node) {
  // mountComponents re-runs on shopify:section:load; drop any previous timer.
  clearInterval(node._bfTimer);
  const raw = (node.dataset.end || '').trim();
  const end = HAS_OFFSET.test(raw) ? Date.parse(raw) : NaN;
  const hideOnEnd = node.dataset.hideOnEnd === 'true';
  const parts = ['days', 'hours', 'minutes', 'seconds'].map((k) => [
    k,
    node.querySelector(`[data-${k}]`),
  ]);

  const render = () => {
    if (!node.isConnected) return clearInterval(node._bfTimer);
    const left = timeLeft(end, Date.now());
    parts.forEach(([k, el]) => {
      if (el) el.textContent = pad(left ? left[k] : 0);
    });
    if (!left) {
      clearInterval(node._bfTimer);
      if (hideOnEnd && !(window.Shopify && window.Shopify.designMode)) {
        node.hidden = true;
      }
    }
  };

  render();
  if (timeLeft(end, Date.now())) node._bfTimer = setInterval(render, 1000);
}

function bfDeals(node) {
  // Re-mount safe: drop listeners from a previous mount.
  if (node._bfDeals) node._bfDeals.abort();
  const { signal } = (node._bfDeals = new AbortController());
  const tabs = [...node.querySelectorAll('[role=tab]')];
  const grid = node.querySelector('[data-grid]');
  const items = [...grid.querySelectorAll('[data-bf-item]')];
  items.forEach((i) => { i.pos = parsePositions(i.dataset.pos || ''); });
  const label = node.querySelector('[data-progress-label]');
  const bar = node.querySelector('[data-progress-bar]');
  const more = node.querySelector('[data-more]');
  const tpls = [...node.querySelectorAll('template[data-promo]')];
  const byPos = {};
  tpls.forEach((t) => { byPos[Number(t.dataset.position)] = byPos[Number(t.dataset.position)] || t; });
  const positions = Object.keys(byPos).map(Number);
  const state = { tab: 'all', pages: 1 };
  const inTab = (tab) => tabOrder(items, tab);

  // Counts come from the DOM; empty tabs are hidden (All always stays).
  tabs.forEach((t) => {
    const n = inTab(t.dataset.tab).length;
    const c = t.querySelector('[data-count]');
    if (c) c.textContent = n;
    t.hidden = t.dataset.tab !== 'all' && !n;
  });

  // Promos are not products: rebuilt from templates, never counted.
  const placePromos = (visible, slots) => {
    grid.querySelectorAll('[data-bf-promo]').forEach((e) => {
      if (!slots.includes(Number(e.dataset.bfPromo))) { if (e._bfIo) e._bfIo.disconnect(); e.remove(); }
    });
    slots.forEach((slot) => {
      // Keep existing promos so a smart-card video doesn't restart.
      if (grid.querySelector(`[data-bf-promo="${slot}"]`)) return;
      const el = byPos[slot].content.firstElementChild.cloneNode(true);
      el.dataset.bfPromo = slot;
      const vid = el.querySelector('[data-bf-video]');
      if (vid) el._bfIo = lazyVideo(vid);
      grid.append(el);
    });
    // Order: products in the tab's SKU order, promos spliced at their slot (1-based, among all tiles).
    const tiles = [...visible];
    [...slots].sort((a, b) => a - b).forEach((slot) => {
      tiles.splice(slot - 1, 0, grid.querySelector(`[data-bf-promo="${slot}"]`));
    });
    tiles.forEach((el) => grid.append(el));
  };

  const render = () => {
    const list = inTab(state.tab);
    const { shown, slots } = pageLayout(list.length, state.pages, state.tab === 'all' ? positions : []);
    const visible = list.slice(0, shown);
    items.forEach((i) => { i.hidden = true; });
    visible.forEach((i) => { i.hidden = false; });
    placePromos(visible, slots);
    label.textContent = node.dataset.progressText.replace('[shown]', shown).replace('[total]', list.length);
    bar.style.width = (list.length ? Math.min(100, (shown / list.length) * 100) : 0) + '%';
    more.hidden = shown >= list.length;
  };

  const activate = (handle) => {
    const tab = tabs.find((t) => t.dataset.tab === handle && !t.hidden) || tabs[0];
    state.tab = tab.dataset.tab;
    state.pages = 1;
    tabs.forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      if (on) node.querySelector('[data-panel]').setAttribute('aria-labelledby', t.id);
    });
    render();
    // Card swipers mounted while hidden measure 0px; Swiper re-measures on resize.
    window.dispatchEvent(new Event('resize'));
  };

  const fromHash = () => {
    const m = /^#deals-(.+)$/.exec(location.hash);
    if (!m) return;
    let handle = m[1];
    try { handle = decodeURIComponent(handle); } catch (e) { handle = ''; } // malformed -> All
    activate(handle);
    node.scrollIntoView({ behavior: 'smooth' });
  };

  tabs.forEach((t) => t.addEventListener('click', () => {
    activate(t.dataset.tab);
    history.replaceState(null, '', '#deals-' + t.dataset.tab);
  }, { signal }));

  tabs.forEach((t, i) => t.addEventListener('keydown', (e) => {
    const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
    if (!d) return;
    e.preventDefault();
    const vis = tabs.filter((x) => !x.hidden);
    const next = vis[(vis.indexOf(t) + d + vis.length) % vis.length];
    next.focus();
    next.click();
  }, { signal }));

  more.addEventListener('click', () => { state.pages++; render(); window.dispatchEvent(new Event('resize')); }, { signal });

  window.addEventListener('hashchange', fromHash, { signal });
  // Same hash as current fires no hashchange, so scroll explicitly.
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href^="#deals-"]');
    if (a && a.hash === location.hash) fromHash();
  }, { signal });
  // Rebuild promos from templates on re-mount so their observers are fresh.
  node.querySelectorAll('[data-bf-promo]').forEach((e) => { if (e._bfIo) e._bfIo.disconnect(); e.remove(); });
  activate('all');
  fromHash();
}

// Category tiles: "From" = cheapest default card price in the matching BF Deals tab.
// Reads data attributes only, so it doesn't depend on bfDeals mounting first.
function bfFromPrices(node) {
  const items = [...document.querySelectorAll('[data-bf-item]')];
  items.forEach((i) => { i.pos = parsePositions(i.dataset.pos || ''); i.price = Number(i.dataset.price); });
  node.querySelectorAll('[data-bf-from]').forEach((el) => {
    const out = el.querySelector('[data-bf-from-price]');
    const best = cheapestInTab(items, el.dataset.bfFrom);
    const shown = best && best.querySelector('[data-product-card-regular-price]');
    if (shown) out.textContent = shown.textContent.trim(); // already formatted for the locale
    if (out.textContent.trim()) el.classList.remove('invisible');
  });
}

// Copy of the theme's updateCartDrawerContent (lib/cart.js isn't importable here).
function refreshCartDrawer(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const swap = (sel) => {
    const cur = document.querySelector(sel);
    const next = doc.querySelector(sel);
    if (cur && next) {
      cur.innerHTML = next.innerHTML;
      if (sel === '[data-cart-drawer-free-shipping]') cur.className = next.className;
    }
  };
  const next = doc.querySelector('[data-cart-drawer-count-number]');
  const count = next ? next.textContent : '';
  const cur = document.querySelector('[data-cart-drawer-count-number]');
  if (cur) cur.textContent = count;
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    const n = count.replace('(', '').replace(')', '');
    el.textContent = n;
    el.classList.toggle('hidden', !(n > 0));
  });
  swap('[data-cart-drawer-content]');
  swap('[data-cart-drawer-footer]');
  swap('[data-cart-drawer-free-shipping]');
  document.dispatchEvent(new CustomEvent('cart:attachListener'));
}

function bfBundle(node) {
  if (node._bfBundle) node._bfBundle.abort();
  const { signal } = (node._bfBundle = new AbortController());
  const q = (s) => node.querySelector(s);
  const variants = JSON.parse(q('[data-mattress]').textContent || '[]') || [];
  const matTitle = q('[data-mattress-title-prefix]').dataset.mattressTitlePrefix;
  const discountPct = Number(node.dataset.discount) || 0;
  const fmtOpts = (d) => [document.documentElement.lang || undefined, {
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD',
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  }];
  const fmtWhole = new Intl.NumberFormat(...fmtOpts(0));
  const fmtCents = new Intl.NumberFormat(...fmtOpts(2));
  // whole amounts without decimals, otherwise exactly 2
  const money = (c) => (Math.round(c) % 100 === 0 ? fmtWhole : fmtCents).format(c / 100);
  const addBtn = q('[data-add]');
  const sizes = [...node.querySelectorAll('[data-size]')];
  let size = sizes[0].dataset.size;
  let mattress = null;
  let busy = false;

  const bedInput = () => q(`[data-list="${size}"] input:checked`);

  const render = () => {
    const bed = bedInput();
    mattress = findVariantBySize(variants, sizes.find((b) => b.dataset.size === size).dataset.match);
    addBtn.disabled = busy || !bed || !mattress || !mattress.available || bed.dataset.available !== 'true';
    if (!bed || !mattress) return;
    const bedPrice = Number(bed.dataset.price);
    const bedCompare = Number(bed.dataset.compare) || bedPrice;
    const mPrice = mattress.price;
    const t = bundleTotals({ bedPrice, bedCompare, mattressPrice: mPrice, mattressCompare: mattress.compare_at_price || 0, discountPct });
    const pct = bedCompare > bedPrice ? Math.round(((bedCompare - bedPrice) * 100) / bedCompare) : 0;
    const bedImg = q('[data-bed-img]');
    bedImg.hidden = !bed.dataset.image; // don't keep the previous bed's image
    if (bed.dataset.image) bedImg.src = bed.dataset.image;
    else bedImg.removeAttribute('src');
    q('[data-bed-title]').textContent = bed.dataset.title;
    q('[data-bed-pct]').textContent = pct ? node.dataset.bedSub.replace('[pct]', pct) : '';
    q('[data-bed-compare]').textContent = pct ? money(bedCompare) : '';
    q('[data-bed-price]').textContent = money(bedPrice);
    const img = mattress.featured_image && mattress.featured_image.src;
    const matImg = q('[data-mat-img]');
    matImg.hidden = !img;
    if (img) matImg.src = img;
    else matImg.removeAttribute('src');
    q('[data-mat-title]').textContent = `${matTitle}, ${mattress.public_title || mattress.title}`;
    q('[data-mat-compare]').textContent = money(mPrice);
    q('[data-mat-price]').textContent = money(t.mattressSale);
    q('[data-total]').textContent = money(t.total);
    q('[data-savings]').textContent = money(t.savings);
  };

  const setSize = (s) => {
    size = s;
    sizes.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.size === s)));
    node.querySelectorAll('[data-list],div[data-image]').forEach((el) => {
      el.hidden = (el.dataset.list || el.dataset.image) !== s;
    });
    // Prefer the first available bed; fall back to the first one.
    const radios = [...node.querySelectorAll(`[data-list="${s}"] input`)];
    const pick = radios.find((r) => r.checked && r.dataset.available === 'true') || radios.find((r) => r.dataset.available === 'true') || radios[0];
    if (pick) pick.checked = true;
    render();
  };

  sizes.forEach((b) => b.addEventListener('click', () => setSize(b.dataset.size), { signal }));
  node.addEventListener('change', (e) => { if (e.target.matches('input[type=radio]')) render(); }, { signal });

  const err = q('[data-error]');
  addBtn.addEventListener('click', async () => {
    if (busy || !mattress || !bedInput()) return;
    busy = true;
    addBtn.disabled = true;
    err.classList.add('hidden');
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(bedInput().value), quantity: 1 }, { id: mattress.id, quantity: 1 }],
          sections: 'cart-drawer',
        }),
      });
      const data = await res.json();
      if (data.sections && data.sections['cart-drawer']) {
        refreshCartDrawer(data.sections['cart-drawer']);
        document.dispatchEvent(new CustomEvent('cart:open'));
      } else {
        const msg = data.description || data.message;
        document.dispatchEvent(new CustomEvent('cart:open'));
        document.dispatchEvent(new CustomEvent('cart:error', { detail: msg }));
        err.textContent = msg || '';
        err.classList.remove('hidden');
      }
    } catch (e) {
      console.error('Error:', e);
      err.textContent = node.dataset.errorText || '';
      err.classList.remove('hidden');
    } finally {
      busy = false;
      render();
    }
  }, { signal });

  setSize(size);
}

function bfUgc(node) {
  if (node._bfUgc) node._bfUgc.abort();
  const { signal } = (node._bfUgc = new AbortController());
  if (node._bfUgcIo && node._bfUgcIo.disconnect) node._bfUgcIo.disconnect();

  const video = node.querySelector('[data-bf-video]');
  const btn = node.querySelector('[data-bf-sound]');
  if (video) {
    node._bfUgcIo = lazyVideo(video);
    if (btn) btn.addEventListener('click', () => {
      video.muted = !video.muted;
      btn.setAttribute('aria-pressed', String(!video.muted));
    }, { signal });
  }

  // Scroll-snap row; arrows scroll one card.
  const track = node.querySelector('[data-bf-track]');
  const prev = node.querySelector('[data-bf-prev]');
  const next = node.querySelector('[data-bf-next]');
  if (!track) return;
  const sync = () => {
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
  };
  const step = () => (track.firstElementChild ? track.firstElementChild.offsetWidth + 16 : track.clientWidth);
  prev.addEventListener('click', () => track.scrollBy({ left: -step() }), { signal });
  next.addEventListener('click', () => track.scrollBy({ left: step() }), { signal });
  track.addEventListener('scroll', sync, { signal, passive: true });
  window.addEventListener('resize', sync, { signal });
  sync();
}

// The selected swatch grows and shifts its neighbours; the cooldown stops a hover chain under a still pointer.
function canHoverSwatch(lastMs, nowMs, cooldownMs = 350) {
  return nowMs - lastMs >= cooldownMs;
}

const helpers = { timeLeft, slotPromos, findVariantBySize, bundleTotals, monthly, pageLayout, canHoverSwatch, parsePositions, tabOrder, cheapestInTab };
const components = { bfCountdown, bfDeals, bfBundle, bfUgc, bfFromPrices };

if (typeof module === 'object' && module.exports) {
  module.exports = helpers;
  return;
}

function mount(root) {
  root.querySelectorAll('[data-bf-component]').forEach((el) => {
    const fn = components[el.dataset.bfComponent];
    if (!fn) return;
    try { fn(el); } catch (e) { console.error(e); }
  });
}
const CARD_SWATCH = '[data-bf-card] [data-option-color]';
const SWATCH_COOLDOWN = 350;
let lastSwatchHover = 0;
let swatchHoverRetry;
// Same as the collection page: hovering a swatch selects it. The click runs the theme's productCard handler.
document.addEventListener('mouseover', (e) => {
  if (!window.matchMedia('(hover: hover)').matches) return;
  const swatch = e.target.closest && e.target.closest(CARD_SWATCH);
  if (!swatch || swatch.classList.contains('swatch-selected')) return;
  const select = () => {
    lastSwatchHover = Date.now();
    swatch.click();
  };
  clearTimeout(swatchHoverRetry);
  if (helpers.canHoverSwatch(lastSwatchHover, Date.now(), SWATCH_COOLDOWN)) { select(); return; }
  // No further mouseover fires if the pointer rests here, so retry once the cooldown ends.
  swatchHoverRetry = setTimeout(() => {
    if (swatch.matches(':hover') && !swatch.classList.contains('swatch-selected')) select();
  }, lastSwatchHover + SWATCH_COOLDOWN - Date.now());
});
document.addEventListener('click', (e) => {
  const swatch = e.target.closest && e.target.closest(CARD_SWATCH);
  if (!swatch) return;
  const card = swatch.closest('[data-bf-card]');
  const name = card.querySelector('[data-bf-swatch-name]');
  if (name) name.textContent = swatch.title;
  // productCard only updates links on slideChange, which skips a swap that stays on slide 0.
  const url = `${card.dataset.productCardUrl}?variant=${swatch.dataset.optionVariantId}`;
  card.querySelectorAll('[data-product-url]').forEach((a) => { a.href = url; });
  // productCard re-adds the class after 300ms, so a quick second click would leave two selected.
  card.bfLastSwatch = swatch;
  setTimeout(() => {
    card.querySelectorAll('[data-option-color]').forEach((x) => x.classList.toggle('swatch-selected', x === card.bfLastSwatch));
  }, 320);
});
window.BFLander = { ...helpers, mount };
const init = () => mount(document);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
document.addEventListener('shopify:section:load', (e) => mount(e.target));
})();
